import { Link } from 'react-router-dom';
import { IoLogInOutline } from 'react-icons/io5';

const PageFooter = () => {
  return (
    <footer className='w-full bg-mainBackColor border-t border-[#1e1e4a] mt-auto'>

      {/* CTA section */}
      <div className='w-full flex flex-col items-center justify-center py-16 px-4 space-y-6 border-b border-[#1e1e4a]'>
        <h3 className='text-white font-bold text-[26px] text-center'>Start trading with us</h3>
        <p className='text-[#ACACB5] text-[15px] text-center max-w-[480px]'>Begin your trading journey today and unlock a world of opportunities.</p>
        <div className='flex flex-col items-center space-y-2 sm:flex-row sm:space-y-0 sm:space-x-3'>
          <Link to="/signin" className="w-[120px] h-[44px] bg-primaryGreen flex justify-center items-center rounded space-x-2 transition-all hover:bg-primaryGreen/90 glow-green">
            <IoLogInOutline className='text-mainBackColor text-[17px]' />
            <p className="text-[14px] text-mainBackColor font-[600]">Sign in</p>
          </Link>
          <a href='mailto:support@zenitchain.com' className="w-[120px] h-[44px] flex bg-[#1e1e4a] justify-center items-center rounded transition-all hover:bg-[#2a2a5a]">
            <p className="text-[14px] text-white">Contact Us</p>
          </a>
        </div>
      </div>

      {/* Bottom bar */}
      <div className='w-full flex flex-col items-center space-y-5 px-4 py-8 md:flex-row md:justify-between md:space-y-0 md:px-[4rem]'>

        <Link to='/' className="flex items-center">
          <span className="font-logo font-[700] text-[18px] tracking-tight text-white">Zenit<span className="text-userDashPurple">chain</span></span>
        </Link>

<div className='flex items-center space-x-4'>
          <p className='text-[13px] text-[#ACACB5]'>© 2024 Zenitchain. All rights reserved.</p>
        </div>

      </div>
    </footer>
  );
};

export default PageFooter;
